// extracted by mini-css-extract-plugin
export default {"buttonDashboards":"Dashboards_buttonDashboards__wqCAD","iconDash":"Dashboards_iconDash__Suh8t","containerBtnDash":"Dashboards_containerBtnDash__G-sSq"};